import axios from 'axios'
import {MessageBox, Message, Notification} from 'element-ui'
import {getToken, setToken} from "./auth";
import {login} from "../api/login";

// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        console.log();
        if (getToken()) {
            // let each request carry token
            // please modify it according to the actual situation
            config.headers['PDZZSWAdminToken'] = getToken()
        }
        return config
    },
    error => {
        // do something with request error
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        // console.log(response.data);
        if (response.data.code === 40002) {
            login({ username: "surea", password: "abc.123" }).then((res) => {
                setToken(res.data);
                location.reload()
            });
        }
        return response.data
    },
    error => {
        console.log(error)
        const {data} = error.response
        if (data.code === 401) {
                console.log(data);
        } else if (data.code === 422) {
            Message({
                message: data.message,
                type: 'error',
                duration: 4 * 1000
            })
        } else if (data.code === 430) {
            MessageBox.confirm(data.message, '', {
                type: 'warning'
            }).then(() => {

            })
        } else if (data.code === 500) {
            Notification.error({
                title: data.message,
                dangerouslyUseHTMLString: true,
                message: `<p>ErrorNumber:${data.data.errorId}</p> We'll deal with it as soon as possible`,
                duration: 0
            })
        } else {
            Message({
                message: data.message,
                type: 'error',
                duration: 5 * 1000
            })
        }
        return Promise.reject(error)
    }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js